import NewSlugInput from './NewSlugInput';

export default NewSlugInput;
